<div class="confirmation-dialog">
  <div class="confirmation-dialog-header">
    <div class="confirmation-dialog-header-left">
      <div class="icon-container">
        <lucide-angular [name]="data.icon" [size]="24" [strokeWidth]="1.5"></lucide-angular>
      </div>
      <div class="title">{{ data.title }}</div>
    </div>
    <lucide-angular name="x" [size]="20" [strokeWidth]="1.5" class="close-icon" (click)="onClose()"></lucide-angular>
  </div>
  <div class="confirmation-dialog-body">
    <div class="content" [innerHtml]="data.content"></div>
  </div>
  <div class="confirmation-dialog-footer">
    <button class="cancel-btn" [mat-dialog-close]="false" (click)="onClose()">
      {{ data.negativeOptionText }}
    </button>
    <button class="confirm-btn" [mat-dialog-close]="true" cdkFocusInitial>
      {{ data.positiveOptionText }}
    </button>
  </div>
</div>
